const thumbsCont = document.querySelector(".product_gallery_nav")

const thumbsObserver = new MutationObserver(() => {
    const thumbs = thumbsCont.querySelectorAll(".gallery-cell");

    thumbs.forEach((thumb) => {
        if (thumb.classList.contains("is-nav-selected")) {
            const isMobile = window.innerWidth < 800;

            if (isMobile) {
                // Horizontal Scroll
                const containerLeft = thumbsCont.getBoundingClientRect().left;
                const thumbLeft = thumb.getBoundingClientRect().left;
                const relativeLeft = thumbLeft - containerLeft;

                thumbsCont.scrollTo({
                    left: thumbsCont.scrollLeft + relativeLeft - thumbsCont.offsetWidth / 2 + thumb.offsetWidth / 2,
                    behavior: "smooth"
                });
            } else {
                // Vertical Scroll
                const containerTop = thumbsCont.getBoundingClientRect().top;
                const thumbTop = thumb.getBoundingClientRect().top;
                const relativeTop = thumbTop - containerTop;

                thumbsCont.scrollTo({
                    top: thumbsCont.scrollTop + relativeTop - thumbsCont.offsetHeight / 2 + thumb.offsetHeight / 2,
                    behavior: "smooth"
                });
            }
        }
    });
});



thumbsObserver.observe(thumbsCont, {
    childList: true,
    subtree: true,
    attributes: true,
})




setTimeout(() => {
    if (document.querySelector(".gallery-media-thumb")) {
        const openMediaModalButton = document.createElement("button")
        openMediaModalButton.innerHTML = `<svg fill="#4d8029" height="20px" width="20px" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 210 210" xml:space="preserve"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path d="M179.07,105L30.93,210V0L179.07,105z"></path> </g></svg>`
        openMediaModalButton.classList.add("open-media-modal")


        if (!document.querySelector(".open-media-modal")) {
            document.querySelector(".product_gallery").prepend(openMediaModalButton)
        }
    }
}, 500)


document.addEventListener("mouseup", (e) => {
    if (e.target.closest(".flickity-next")) {
        const slideTarget = document.querySelector(".thumb-gallery .is-nav-selected")
        if (slideTarget.nextElementSibling) {
            slideTarget.nextElementSibling.click()
        }
    } else if (e.target.matches(".flickity-prev")) {
        const slideTarget = document.querySelector(".thumb-gallery .is-nav-selected")
        if (slideTarget.previousElementSibling) {
            slideTarget.previousElementSibling.click()
        }
    }

    if (e.target.closest(".open-media-modal") || e.target.closest(".close-media-modal") || e.target.closest(".media-product-modal")) {
        const iframe = document.querySelector(".media-product-modal iframe");
        const iframeSrc = iframe.src;
        iframe.src = iframeSrc;
        if (document.querySelector(".media-product-modal").classList.contains("is-open")) {
            document.querySelector(".media-product-modal").classList.remove("is-open")
        } else {
            document.querySelector(".media-product-modal").classList.add("is-open")
        }
    }
})


